export const colors = {
  /* Brand */
  mainDark:    '#141824',   // near-black ink
  mainColor:   '#C9845A',   // amber — use sparingly

  /* Surfaces */
  white:       '#FFFFFF',
  ghostWhite:  '#F6F3EE',   // warm page shell
  ghostWhite2: '#EEEAE3',

  /* Borders */
  aliceBlue:   '#D8D2CA',
  aliceBlue2:  '#E3DDD6',   // standard component border

  /* Text */
  textColor:         '#141824',
  bodyTextColor:     '#6A6E7D',
  secondaryTextColor:'#9BA0AE',

  /* Semantic */
  successGreen: '#1A9B6C',
  successBg:    '#EBF7F3',
  warningAmber: '#C9845A',
  warningBg:    '#FCF5EF',
  infoBlue:     '#2F72C8',
  infoBg:       '#EBF3FD',
  dangerRed:    '#CC3737',
  dangerBg:     '#FDEDEC',

  /* Legacy / compat */
  lavenderMist:       '#DBE3F5',
  imageBackground:    '#F6F3EE',
  antiFlashWhite:     '#E3DDD6',
  transparent:        'transparent',
};

export const theme = {colors};
